import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualNoticesPage() {
    return <MarkdownDocPage title="Notices" markdownUrl="/docs/user-manual/pages/notices.md" />;
}

